<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="分类名称" prop="name">
                <a-input v-model="queryParam.name" placeholder="请输入分类名称" allow-clear/>
              </a-form-item>
            </a-col>
            <template v-if="advanced">
            </template>
            <a-col :md="!advanced && 8 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['category:category:add']">
          <a-icon type="plus" />新增
        </a-button>
        <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" v-hasPermi="['category:category:edit']">
          <a-icon type="edit" />修改
        </a-button>
        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['category:category:remove']">
          <a-icon type="delete" />删除
        </a-button>
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['category:category:edit']">
            <a-icon type="edit" />修改
          </a>
          <a-divider type="vertical" v-hasPermi="['category:category:remove']" />
          <a @click="handleDelete(record)" v-hasPermi="['category:category:remove']">
            <a-icon type="delete" />删除
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageCategory,listCategory, delCategory } from '@/api/category/category'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'Category',
  components: {
    CreateForm
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        name: null,
        parentId: null,
        certificate: null,
        insurance: null,
        certificateName: null,
        type: 2,
        status: null,
        insuranceMoney: null,
        suretyMoney: null,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: '序号',
          dataIndex: 'id',
          ellipsis: true,
          align: 'center',
          width: 80,
          customRender: (text, record, index) => {
            return index + 1
          }
        },
        // {
        //   title: '工种id',
        //   dataIndex: 'id',
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: '分类名称',
          dataIndex: 'name',
          ellipsis: true,
          align: 'center'
        },
        // {
        //   title: '上级名称',
        //   dataIndex: 'parentId',
        //   ellipsis: true,
        //   align: 'center'
        // },
        // {
        //   title: '是否需要认证',
        //   dataIndex: 'certificate',
        //   ellipsis: true,
        //   align: 'center',
        //   customRender(f){
        //     if(f == 0){
        //       return '不需要'
        //     }else{
        //       return '需要'
        //     }
        //   }
        // },
        {
          title: '保险分类',
          dataIndex: 'insurance',
          ellipsis: true,
          align: 'center',
          customRender(f){
            if(f == 1){
              return 'A类'
            }else if(f == 2){
              return 'B类'
            }else if(f == 3){
              return 'C类'
            }else if(f == 4){
              return 'D类'
            }else if(f == 5){
              return '一类'
            }else if(f == 6){
              return '二类'
            }else if(f == 7){
              return '三类'
            }else if(f == 8){
              return '四类'
            }else if(f == 9){
              return '五类'
            }else if(f == 10){
              return '六类'
            }else if(f == 11){
              return 'S类'
            }
          }
        },
        // {
        //   title: '证书名称',
        //   dataIndex: 'certificateName',
        //   ellipsis: true,
        //   align: 'center'
        // },
        // {
        //   title: '工种状态',
        //   dataIndex: 'type',
        //   ellipsis: true,
        //   align: 'center',
        //   //，0-工种层级，1-标签
        //   customRender(f){
        //     if(f == 0){
        //       return '层级'
        //     }else{
        //       return '标签'
        //     }
        //   }
        // },
        // {
        //   title: '层级',
        //   dataIndex: 'status',
        //   ellipsis: true,
        //   align: 'center',
        //   //0-顶级，1-一级，2-二级
        //   customRender(f){
        //     if(f == 0){
        //       return '顶级'
        //     }else if(f == 1){
        //       return '一级'
        //     }else{
        //       return '二级'
        //     }
        //   }
        // },
        // {
        //   title: '保险费用',
        //   dataIndex: 'insuranceMoney',
        //   ellipsis: true,
        //   align: 'center'
        // },
        // {
        //   title: '保证金费用',
        //   dataIndex: 'suretyMoney',
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '备注',
          dataIndex: 'remark',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: '18%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created () {
    this.getList()
  },
  computed: {
  },
  watch: {
  },
  methods: {
    /** 查询工种列表 */
    getList () {
      this.loading = true
     pageCategory(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        name: undefined,
        parentId: undefined,
        certificate: undefined,
        insurance: undefined,
        certificateName: undefined,
        type: 2,
        status: undefined,
        insuranceMoney: undefined,
        suretyMoney: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids.push(row.id)
      }
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中编号为' + ids + '的数据',
        onOk () {
          let data = []
          that.ids.map(id => data.push({"id":id}))
          return delCategory(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                '删除成功',
                3
              )
          })
        },
        onCancel () {
          //取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk () {
          that.download('category/category/export', {
            ...that.queryParam
          }, `工种_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    }
  }
}
</script>
